import { render } from "./WhatIsMy.vue?vue&type=template&id=2f09fa14&scoped=true"
import script from "./WhatIsMy.vue?vue&type=script&lang=js"
export * from "./WhatIsMy.vue?vue&type=script&lang=js"

import "./WhatIsMy.vue?vue&type=style&index=0&id=2f09fa14&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f09fa14"]])

export default __exports__